export type FamilyDeleteError = {
  response?: {
    status?: number;
    data?: unknown;
  };
};

const asRecord = (value: unknown): Record<string, unknown> | null =>
  value != null && typeof value === "object" ? value as Record<string, unknown> : null;

export const getBlockingChildCount = (error: unknown): number | null => {
  const response = asRecord(error)?.response;
  const data = asRecord(asRecord(response)?.data);
  const details = asRecord(data?.details);
  const candidates = [
    data?.blockingChildCount,
    data?.childCount,
    data?.childrenCount,
    details?.blockingChildCount,
    details?.childCount,
    details?.childrenCount,
  ];

  for (const candidate of candidates) {
    const parsed = typeof candidate === "number" ? candidate : Number(candidate);
    if (Number.isInteger(parsed) && parsed >= 0) return parsed;
  }
  for (const text of [data?.detail, data?.message, data?.title]) {
    if (typeof text !== "string") continue;
    const match = text.match(/\b(\d+)\s+child(?:ren)?\b/i);
    if (match) return Number(match[1]);
  }
  return null;
};

export const isFamilyDeleteBlocked = (error: unknown): boolean =>
  asRecord(asRecord(error)?.response)?.status === 409 &&
  [
    asRecord(asRecord(asRecord(error)?.response)?.data)?.detail,
    asRecord(asRecord(asRecord(error)?.response)?.data)?.message,
  ].some((text) =>
    typeof text === "string" &&
    /family cannot be deleted because \d+ child(?:ren)? (?:is|are) still linked/i.test(text)
  );
